import { NavItemType } from 'types';
import { getDynamicExternalApps } from './dynamic-external-apps';

// פונקציה שמחזירה את התפריט הצדדי עם אפליקציות חיצוניות דינמיות (משותף ל־menu-items ול־useDynamicMenuItems)
export const getSidebarPagesNavGroup = (): NavItemType => {
  const dynamicExternalApps = getDynamicExternalApps();

  return {
    id: 'sidebar-pages',
    title: 'sidebar.nav.additionalPages',
    type: 'group',
    children: [...dynamicExternalApps],
  };
};

const viewsPages: NavItemType = getSidebarPagesNavGroup();

export default viewsPages;
